"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = void 0;
var Avatar_1 = __importDefault(require("./Avatar"));
exports.Avatar = Avatar_1.default;
exports.default = Avatar_1.default;
//# sourceMappingURL=index.js.map